import React from "react";
import { Mui } from "@osu/react-ui";
import ACTScores from "./scoresAct";
import SATScores from "./scoresSat";
import BestTest from "./scoresBest";
import OtherScores from "./scoresOther";

const Scores = (props) => {
  const { studentData } = props;
  
  // Check if scores and bestTest are empty or missing
  const scores = studentData?.data?.scores;
  const hasBestTest = studentData?.data?.bestTest?.score !== "";

  const committeeId = studentData?.data?.demographics?.committeeId;
  const isCCP = ["ccp-metro-hs", "ccp-academy", "ccp-academy-regional"].includes(committeeId);

  const ccpHasAnyScores =
    scores &&
    (
      scores.act?.length ||
      scores.sat?.length ||
      scores.accuplacer?.length
    );

  if (
    (isCCP && !ccpHasAnyScores && !hasBestTest) ||
    (!isCCP && !hasBestTest)
  ) {
    if (!isCCP && !hasBestTest && studentData?.data?.demographics?.testScoresNotRequired === true) {
      return (
        <Mui.Box>
          <Mui.Typography style={{ color: "#f70606ff" }}>Test Scores Not Required</Mui.Typography>
          <Mui.Typography>No test information available</Mui.Typography>
        </Mui.Box>
      );
    } else {
      return (
        <Mui.Typography>No test information available</Mui.Typography>
      );
    }
  }

  if (isCCP) {
    return (
      <Mui.Box>
        <BestTest studentData={studentData} />
        <ACTScores studentData={studentData} />
        <SATScores studentData={studentData} />
        <OtherScores studentData={studentData}/>
      </Mui.Box>
    );
  } else if (!isCCP && studentData?.data?.demographics?.testScoresNotRequired === true) {
    return (
      <Mui.Box>
        <Mui.Typography style={{ color: "#f70606ff" }}>Test Scores Not Required</Mui.Typography>
        <BestTest studentData={studentData} />  
      </Mui.Box>
    );
  } else {
    return (
      <Mui.Box>
        <BestTest studentData={studentData} />
      </Mui.Box>
    );
  }
};

export default Scores;
